import {generateInitialState} from "@/helpers/generateInitialState";
import {createSlice, isAnyOf} from "@reduxjs/toolkit";
import {testsInitialState} from "../initialStates";
import {loadAllPlusTests, loadAllTests} from "./testsActions";

const initialState = await generateInitialState("tests", testsInitialState);

const testsSlice = createSlice({
  name: "tests",
  initialState,
  reducers: {
    updatePlusTestsState: (state, action) => {
      state.isFetching = false;
      state.hasFailed = false;
      state.errorMsg = "";
      state.plusTests = [...action.payload];
    },
    setModalContent: (state, action) => {
      state.isFetching = false;
      state.hasFailed = false;
      state.errorMsg = "";
      state.modal = {...action.payload};
    },
    cleanModalContent: (state, action) => {
      state.isFetching = false;
      state.hasFailed = false;
      state.errorMsg = "";
      state.modal = {};
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadAllTests.fulfilled, (state, action) => {
        state.isFetching = false;
        state.hasFailed = true;
        state.data = [...action.payload];
        state.errorMsg = "";
      })
      .addCase(loadAllPlusTests.fulfilled, (state, action) => {
        state.isFetching = false;
        state.hasFailed = true;
        state.plusTests = [...action.payload];
        state.errorMsg = "";
      })
      .addMatcher(isAnyOf(loadAllTests.pending, loadAllPlusTests.pending), (state, action) => {
        state.hasFailed = false;
        state.isFetching = true;
        state.errorMsg = "";
      })
      .addMatcher(isAnyOf(loadAllTests.rejected, loadAllPlusTests.rejected), (state, action) => {
        const {message = "Something went wrong"} = action.payload || {};

        state.hasFailed = true;
        state.isFetching = false;
        state.errorMsg = message;
      });
  },
  selectors: {
    testsDataSelector: state => state.data,
    plusTestsSelector: state => state.plusTests,
    testModalSelector: state => state.modal,
    testStatusSelector: state => ({
      isFetching: state.isFetching,
      hasFailed: state.hasFailed,
      errorMsg: state.errorMsg,
    }),
  },
});

export const {cleanModalContent, setModalContent, updatePlusTestsState} = testsSlice.actions;
export const {testsDataSelector, plusTestsSelector, testModalSelector, testStatusSelector} = testsSlice.selectors;
export default testsSlice.reducer;
